import DOMPurify from 'dompurify';
import { HomeScreenButtonProps } from './HomeScreenButton.types';
import arrowsIcon from '../../static/icons/icon_arrows_homescreen.svg';
import babyBoyIcon from '../../static/icons/baby-boy.png';
import coachIcon from '../../static/icons/icon_coach_homescreen.svg';
import informationIcon from '../../static/icons/information-less-intense.png';
import modulesIcon from '../../static/icons/icon_modules_homescreen.svg';
import pregnantIcon from '../../static/icons/pregnant-less-intense.png';
import protocolIcon from '../../static/icons/icon_protocol_homescreen.svg';
import starIcon from '../../static/icons/icon_star_homescreen.svg';

const homeScreenIcons: Record<string, string> = {
    'baby-boy.png': babyBoyIcon,
    'icon_arrows_homescreen.svg': arrowsIcon,
    'icon_coach_homescreen.svg': coachIcon,
    'icon_modules_homescreen.svg': modulesIcon,
    'icon_protocol_homescreen.svg': protocolIcon,
    'icon_star_homescreen.svg': starIcon,
    'information-less-intense.png': informationIcon,
    'pregnant-less-intense.png': pregnantIcon
};

type Properties = {
    buttonProps: HomeScreenButtonProps;
    action: () => void;
    disabled?: boolean;
    isHidden?: boolean;
};

const HomeScreenButton = (props: Properties) => {
    if (props.isHidden) {
        return <></>;
    }

    let className = 'home-button';
    if (props.disabled) {
        className += ' home-button-disabled';
    }

    let onClickAction = props.action;
    if (props.disabled) {
        onClickAction = () => { return; };
    }

    const imageSource = homeScreenIcons[props.buttonProps.iconPath];
    const safeSvg: string = DOMPurify.sanitize(props.buttonProps.customIconSvg || '');

    return (
        <div className={className} onClick={onClickAction}>
            <div className="icon">
                {props.buttonProps.customIconSvg ? <div dangerouslySetInnerHTML={{ __html: safeSvg }} /> : <img src={imageSource} style={{objectFit: 'contain'}}/>}
            </div>
            <span className="title">{props.buttonProps.label}</span>
        </div>
    );
};
export default HomeScreenButton;